import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ChangeElementTypologyDialog,
  FormSubmitButtons,
  GridWrap,
  InfoWrapper,
  RHFSelect,
  RHFTagAutocomplete,
} from 'components';
import { tipoElementoAggiuntivoCollegamentiOptions } from 'constants/selectOptions';
import { INFO } from 'pages/Inspections/config/info';
import {
  getSchedaDifettiElementoAggiuntivoCollegamenti as getSchedaDifetti,
  getTipologiaOptionsElementoAggiuntivoCollegamenti as getTipologiaOptions,
} from 'utils/Inspections/L1/collegamentiElementiAggiuntivi';
import { resetObjectSchedaIspezione } from 'utils/Inspections/L1/resetSchedaIspezione';
import useSchedaDifetti from 'utils/Inspections/L1/schedeDifetti';
import { isNullOrUndefinedOrEmptyString } from 'utils/utilities';

const ElementiAggiuntiviForm = ({
  elementiExtraFields,
  selected,
  setSelected,
  elementiExtraTable,
  selectedIdx,
}) => {
  const { getValues, setValue, watch } = useFormContext({
    defaultValues: {
      elementiAggiuntiviTableValue: [],
      tipoElementoAggiuntivoTableValue: '',
      tipologiaElementoAggiuntivoTableValue: '',
    },
  });

  const { populateSchedaDifetti } = useSchedaDifetti();

  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  const tipoElementoWatch = watch('tipoElementoAggiuntivoTableValue');

  useEffect(() => {
    setValue('elementiAggiuntiviTableValue', selected);
  }, [selected]);

  useEffect(() => {
    onResetElementiExtra();
  }, [selectedIdx]);

  const changeAutocomplete = value => {
    setSelected(value);
  };

  const changeElementiExtra = () => {
    const tipoElementoExtraTableValue = getValues(
      'tipoElementoAggiuntivoTableValue'
    );
    const tipologiaElementoExtraTableValue = getValues(
      'tipologiaElementoAggiuntivoTableValue'
    );

    const ids = selected.map(el => el.codice);

    const elementiExtra = [...elementiExtraFields];

    elementiExtra.map((x, index) => {
      if (ids.includes(x?.codice)) {
        elementiExtra[index] = {
          ...x,
          tipoElementoExtra: tipoElementoExtraTableValue,
          tipologiaElementoExtra: tipologiaElementoExtraTableValue,
          ...(tipologiaElementoExtraTableValue !== x.tipologiaElementoExtra ||
          tipoElementoExtraTableValue !== x.tipoElementoExtra
            ? {
                ...resetObjectSchedaIspezione,
                schedaDifetti: getSchedaDifetti(
                  populateSchedaDifetti,
                  tipoElementoExtraTableValue,
                  tipologiaElementoExtraTableValue
                ).map(el => {
                  return {
                    ...el,
                    visto: false,
                    statoDifetto: '',
                    estensioneDifetto: '',
                    intensitaDifetto: '',
                    ps: false,
                    note: '',
                    media: [],
                  };
                }),
              }
            : null),
        };
      }
    });

    setValue(elementiExtraTable, elementiExtra);
    onResetElementiExtra();
  };

  const onConfirmChangeElementiExtra = () => {
    setOpenConfirmationDialog(false);
    changeElementiExtra();
  };

  const onSubmitElementiExtra = () => {
    const tipoElementoExtraTableValue = getValues(
      'tipoElementoAggiuntivoTableValue'
    );
    const tipologiaElementoExtraTableValue = getValues(
      'tipologiaElementoAggiuntivoTableValue'
    );

    const ids = selected.map(el => el.codice);

    const elementiExtra = [...elementiExtraFields];

    const hasChangedTipologia = elementiExtra.some(el => {
      if (ids.includes(el?.codice)) {
        return (
          (tipologiaElementoExtraTableValue !== el.tipologiaElementoExtra ||
            tipoElementoExtraTableValue !== el.tipoElementoExtra) &&
          !isNullOrUndefinedOrEmptyString(el.tipologiaElementoExtra)
        );
      }
    });

    if (hasChangedTipologia) {
      setOpenConfirmationDialog(true);
    } else {
      changeElementiExtra();
    }
  };

  const onResetElementiExtra = () => {
    setValue('elementiAggiuntiviTableValue', []);
    setValue('tipoElementoAggiuntivoTableValue', '');
    setValue('tipologiaElementoAggiuntivoTableValue', '');
    setSelected([]);
  };

  return (
    <>
      <GridWrap container spacing={2} mt={2}>
        <InfoWrapper
          size={3}
          infoMessage={INFO.elementiExtraSelezionati.infoMessage}
        >
          <RHFTagAutocomplete
            multiple={true}
            id="tags-elementiExtra"
            name={'elementiAggiuntiviTableValue'}
            changeAutocomplete={value => {
              changeAutocomplete(value);
            }}
            labelName={'option.codice'}
            getOptionLabel={option => option.codice}
            opt={elementiExtraFields?.filter(
              el => !selected?.some(s => s?.id === el?.id)
            )}
            label="Elementi Aggiuntivi selezionati"
          />
        </InfoWrapper>
        <GridWrap item xs={3}>
          <RHFSelect
            name="tipoElementoAggiuntivoTableValue"
            label="Tipo Elemento*"
            defaultValue={''}
            onChange={e => {
              const nuovoTipo = e.target.value;
              setValue('tipoElementoAggiuntivoTableValue', nuovoTipo);
              const tipologiaAttuale = getValues(
                'tipologiaElementoAggiuntivoTableValue'
              );
              const tipologiaAncoraAmmissibile = getTipologiaOptions(
                nuovoTipo
              ).some(o => o.value === tipologiaAttuale);
              if (!tipologiaAncoraAmmissibile) {
                setValue('tipologiaElementoAggiuntivoTableValue', '');
              }
            }}
            selectOptions={tipoElementoAggiuntivoCollegamentiOptions}
          />
        </GridWrap>
        <GridWrap item xs={3}>
          <RHFSelect
            name="tipologiaElementoAggiuntivoTableValue"
            label="Tipologia Elemento*"
            defaultValue={''}
            onChange={e => {
              setValue('tipologiaElementoAggiuntivoTableValue', e.target.value);
            }}
            selectOptions={getTipologiaOptions(tipoElementoWatch)}
          />
        </GridWrap>
        <GridWrap item xs="auto" alignSelf="center" sx={{ ml: 'auto' }}>
          <FormSubmitButtons
            onSubmit={onSubmitElementiExtra}
            onReset={onResetElementiExtra}
          />
        </GridWrap>
      </GridWrap>
      <ChangeElementTypologyDialog
        open={openConfirmationDialog}
        onClose={() => setOpenConfirmationDialog(false)}
        onConfirm={onConfirmChangeElementiExtra}
      />
    </>
  );
};
ElementiAggiuntiviForm.propTypes = {
  elementiExtraFields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      codice: PropTypes.string,
      tipoElementoExtra: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      tipologiaElementoExtra: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    })
  ),
  selected: PropTypes.array,
  setSelected: PropTypes.func,
  elementiExtraTable: PropTypes.string,
  selectedIdx: PropTypes.number,
};

export default ElementiAggiuntiviForm;
